// Radio group options
export const StartHearingOption = (t: any) => [
  {
    label: t('dialogs.joinHearing.liveFeed'),
    value: '1',
  },
  {
    label: t('dialogs.joinHearing.externalLink'),
    value: '2',
  },
];
